import styled from 'styled-components';

export const BannerWrapper = styled.div`
	padding: 24px;
	display: flex;
	align-items: stretch;

	> * {
		flex: 1;
		min-height: 60px;
		box-shadow: 0 2px 4px rgba(35, 35, 52, 0.12);
	}
`;
